Vuex = require('vuex').default

module.exports = class RootStoreModule

  modules: null

  setup: ->

  getVuexStore: ->
    @_vuexStore or= new Vuex.Store(@getVuexStoreConfig())

  getVuexState: ->
    @getVuexStore().state

  getVuexStoreConfig: ->
    @_vuexStoreConfig or=
      state: {}
      getters: {}
      mutations: {}
      actions: {}
      modules:
        settings:     require('shared/store/settings')
        cookie:       require('shared/store/cookie')
        net:          require('shared/store/net')
        popups:       require('shared/store/popups')
        window:       require('shared/store/window')
        accordion:    require('./accordion')
        lightbox:     require('./lightbox')
        partners:     require('./partners')
        server:       require('./server')
        googleMaps:   require('./google_maps')




// WEBPACK FOOTER //
// ./assets/js/frontend/store/index.coffee